import React, { useEffect } from "react";
import { Modal, Card, Typography, Form, Input, Row, Col, Space, Button } from "antd";
import { CloseOutlined, StopOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { formatNumber } from "../../../utils/funcHelper";

const { Title, Text } = Typography;

const PaymentCancelModal = ({ isOpen, onClose, onConfirm, record }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (isOpen) {
      form.resetFields();
    }
  }, [isOpen]);

  const handleFinish = (values) => {
    onConfirm?.(values?.cancelled_reason || "");
    onClose();
  };

  return (
    <Modal
      title="Huỷ phiếu thanh toán"
      open={isOpen}
      onCancel={onClose}
      footer={null}
      width={640}
      destroyOnClose
    >
      <Space direction="vertical" style={{ width: "100%" }} size={12}>
        <Card size="small" style={{ borderRadius: 8 }}>
          <Title level={5} style={{ marginBottom: 8 }}>Thông tin phiếu</Title>
          <Row gutter={16}>
            <Col span={12}>
              <Text><strong>Mã phiếu:</strong> {record?.payment_code || "-"}</Text>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <Text><strong>Ngày:</strong> {record?.payment_date ? dayjs(record.payment_date).format("DD/MM/YYYY") : "-"}</Text>
            </Col>
          </Row>
          <Row gutter={16} style={{ marginTop: 8 }}>
            <Col span={24} style={{ textAlign: "right" }}>
              <Text><strong>Số tiền:</strong> {formatNumber(record?.amount || 0, 0)} đ</Text>
            </Col>
          </Row>
        </Card>

        <Card size="small" style={{ borderRadius: 8 }}>
          <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Form.Item
              name="cancelled_reason"
              label="Lý do huỷ"
              rules={[
                { required: true, message: "Vui lòng nhập lý do huỷ" },
                { min: 5, message: "Lý do tối thiểu 5 ký tự" },
              ]}
            >
              <Input.TextArea rows={4} placeholder="Nhập lý do huỷ phiếu..." />
            </Form.Item>

            <Row justify="end">
              <Space>
                <Button onClick={onClose} icon={<CloseOutlined />}>Đóng</Button>
                <Button type="primary" danger htmlType="submit" icon={<StopOutlined />}>
                  Xác nhận huỷ
                </Button>
              </Space>
            </Row>
          </Form>
        </Card>
      </Space>
    </Modal>
  );
};

export default React.memo(PaymentCancelModal);